import {
    FETCH_ACCOUNT_STATUS_REQUEST,
    FETCH_ACCOUNT_STATUS_SUCCESS,
    FETCH_ACCOUNT_STATUS_FAILURE
} from './constants';


export const fetchAccountStatusRequest = (params: any) => ({
    type: FETCH_ACCOUNT_STATUS_REQUEST,
    payload: params,
})

export const fetchAccountStatusSuccess = (payload: { data: any, meta: { total: number } }) => ({
  type: FETCH_ACCOUNT_STATUS_SUCCESS,
  payload,
});
export const fetchAccountStatusFailure = (error: any) => ({
    type: FETCH_ACCOUNT_STATUS_FAILURE,
    payload: error,
})

